module.exports = "<div class=\"weui_btn_area\"><slot></div>";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./components/button/button-area.vue
 ** module id = 51
 ** module chunks = 0
 **/